const error = {
  GENERAL: 'GENERAL',
  BAD_REQUEST: 'BAD_REQUEST',
  BAD_REQUEST2: 'BAD REQUEST',
  DEFAULT_INVALID_REQUEST: 'DEFAULT_INVALID_REQUEST',
  INVALID_REQUEST: 'INVALID_REQUEST',
  FORBIDDEN: 'FORBIDDEN',
  NOT_FOUND: 'NOT_FOUND',
  INVALID_JSON: 'INVALID_JSON',
  VALIDATION_FAILED: 'VALIDATION_FAILED',
  ALREADY_EXISTS: 'ALREADY_EXISTS',
  STILL_REFERENCED: 'STILL_REFERENCED',
  SERVICE_UNAVAILABLE: 'SERVICE UNAVAILABLE'
}

export default error
